import { render } from "./SiteLayout.vue?vue&type=template&id=780c618b&scoped=true"
import script from "./SiteLayout.vue?vue&type=script&lang=js"
export * from "./SiteLayout.vue?vue&type=script&lang=js"

import "./SiteLayout.vue?vue&type=style&index=0&id=780c618b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-780c618b"]])

export default __exports__